import { Country, Maybe } from '../../common/data.js';
import { Component } from 'preact';
import { countries } from '../../common/data/countries.js';
import { generateId } from '../../common/util.js';
import { LabeledInput, LabeledInputProps } from './labeled-input.js';

interface CountryPickerProps extends Omit<LabeledInputProps, 'value' | 'handler' | 'select'> {
	value?: Maybe<Country | string>;
	source?: Country[];
	handler: (country: Maybe<Country>) => void;
	sovereign?: boolean;
	flag?: boolean;
}

interface CountryPickerState {
	id: string;
}

export class CountryPicker extends Component<CountryPickerProps, CountryPickerState> {
	
	constructor(props: CountryPickerProps) {
		super(props);
		this.state = { id: generateId() };
	}
	
	render({ flag, placeholder, source, sovereign, value, handler, ...props }: CountryPickerProps, state: CountryPickerState) {
		
		const list = source || countries.filter(c => {
			if (sovereign && c.sovereign === false) return false;
			if (flag && c.flag === false) return false;
			return true;
		});
		const priority = list
			.filter(c => c.priority)
			.sort((a, b) => (b.priority! - a.priority!) || a.name.localeCompare(b.name));
		
		const country = typeof value == 'string' ? list.find(c => c.id == value) : value;
		
		return <LabeledInput
			select={true}
			value={country?.id}
			handler={id => handler(list.find(c => c.id == id) || null)}
			{...props}
		>
			<option value=""></option>
			{priority.map(c => <option value={c.id}>{c.name}</option>)}
			<option value="" />
			{list.map(c => <option value={c.id}>{c.name}</option>)}
		</LabeledInput>;
	}

}
